<template>
  <div
    ref="animationWrapper"
    class="block h-[650px] w-[650px] overflow-visible min-w-[650px]"
  />
</template>

<script setup lang="ts">
import { Particles } from '@onereach/particles';
import { useDebounceFn, useEventListener } from '@vueuse/core';
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { useRoute } from 'vue-router';

import OnereachLogo from '../../assets/login-logo-next.png';

let animation: Particles | null = null;
const route = useRoute();
const customLogo = window.self !== window.top && route.query.logo;
const animationDelay = 3500;

const animationWrapper = ref<HTMLElement>();
const isHovered = ref(false);

const pauseOnHover = () => {
  isHovered.value = false;
  pauseIfNotHovered();
};

const activateOnHover = () => {
  isHovered.value = true;
  if (!animation?.renderProcessId) {
    animation?.render();
  }
};

const pauseIfNotHovered = useDebounceFn(() => {
  if (!isHovered.value) {
    animation?.pauseAnimation();
  }
}, animationDelay);

onMounted(async () => {
  animation = new Particles({
    container: animationWrapper.value!,
    imagePath: customLogo || OnereachLogo,
    options: {
      particleSize: 2,
      particlesAmount: 120000,
    },
  });

  await animation.init();

  isHovered.value = animationWrapper.value?.matches(':hover') || false;
  if (!document.hidden) {
    animate();
  } else {
    useEventListener(window, 'focus', animate, { once: true });
  }

  useEventListener(animationWrapper, 'mouseenter', activateOnHover);
  useEventListener(animationWrapper, 'mouseleave', pauseOnHover);
});

const animate = () => {
  animation?.reveal();
  pauseIfNotHovered();
};

onBeforeUnmount(() => {
  animation?.destroy();
});
</script>
